/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.toggleMenu)();
	  (0, _module.animScroll)();
	  (0, _module.animLoad)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animLoad = exports.animScroll = exports.preloadIndex = exports.preload = exports.toggleMenu = exports.anchorLink = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var toggleMenu = function toggleMenu() {
	  $('.header-hamburger_button,.header-fixed').on('click', function () {
	    $(".header-hamburger_button").toggleClass("open");
	    $(".header-fixed").toggleClass("open");
	  });
	  $('.header-fixed_inner').on('click', function (e) {
	    e.stopImmediatePropagation();
	  });
	}; // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var preload = function preload() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	    $(".st-Container").css("opacity", "");
	  });
	}; // ------------------------------------------------------------------------
	// preloadIndex
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var preloadIndex = function preloadIndex() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	    idxLoading();
	  });
	}; // ------------------------------------------------------------------------
	// idxLoading
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preloadIndex = preloadIndex;
	
	var enableContents = function enableContents() {
	  $(".idx-Loading").removeClass("open");
	  $(".idx-Loading").addClass("close");
	  $(".st-Container").css("opacity", "");
	  $(".js-ld").toggleClass("animated");
	  lscache.set('loading', {
	    'trg': 1
	  }, 1440);
	};
	
	var idxLoading = function idxLoading() {
	  var flag = lscache.get('loading');
	  var trg = flag ? flag.trg : 0;
	  console.log(trg);
	
	  if (trg == 1) {
	    enableContents();
	  } else {
	    $(".idx-Loading").addClass("open");
	    setTimeout(function () {
	      enableContents();
	    }, 3000);
	  }
	}; // ------------------------------------------------------------------------
	// animScroll
	// ------------------------------------------------------------------------
	
	
	var animScroll = function animScroll() {
	  $(window).on("load", function () {
	    var margin = 0;
	
	    if (matchMedia('(max-width: 768px)').matches) {
	      margin = 150;
	    } else {
	      margin = 300;
	    }
	
	    $(".js-sc").each(function (i, node) {
	      gsap.to(node, {
	        scrollTrigger: {
	          trigger: node,
	          start: 'top bottom-=' + margin,
	          toggleClass: {
	            targets: node,
	            className: "animated"
	          },
	          once: true
	        }
	      });
	    });
	  });
	}; // ------------------------------------------------------------------------
	// animLoad
	// ------------------------------------------------------------------------
	
	
	exports.animScroll = animScroll;
	
	var animLoad = function animLoad() {
	  $(window).on("load", function () {
	    $(".js-ld").toggleClass("animated");
	  });
	};
	
	exports.animLoad = animLoad;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common/app.bundle.js